import { render } from "./DraftsView.vue?vue&type=template&id=24bde90c&scoped=true"
import script from "./DraftsView.vue?vue&type=script&lang=js"
export * from "./DraftsView.vue?vue&type=script&lang=js"

import "./DraftsView.vue?vue&type=style&index=0&id=24bde90c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bde90c"]])

export default __exports__